export default function initModals() {
    $(".abre-modal").on("click", function () {
        var modal = $(this).data("modal");
        $("#" + modal).fadeIn();
    });

    $(".modal-content .close, .modal .close").on("click", function () {
        $(this).closest(".modal").fadeOut();
    });

    $(".modal").on("click", function (e) {
        if (e.target === this) {
            $(this).fadeOut();
        }
    });

    $(".modal-content").on("click", function (event) {
        event.stopPropagation();
    });

    $(".menu-link.email").on("click", function () {
        $("#modalFormulario").fadeIn();
    });

    $(".menu-link.phone").on("click", function () {
        $("#modalTelefone").fadeIn();
    });

    $(".link-politica-de-privacidade").on("click", function () {
        $("#modalPoliticaDePrivacidade").fadeIn();
    });

    $(".link-aviso-portal").on("click", function () {
        $("#modalAvisoPortal").fadeIn();
    });
}
